"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgEventStatusResponse = void 0;
var OrgEventStatusResponse;
(function (OrgEventStatusResponse) {
    OrgEventStatusResponse[OrgEventStatusResponse["NOT_RESPONDED"] = 0] = "NOT_RESPONDED";
    OrgEventStatusResponse[OrgEventStatusResponse["DONT_KNOW"] = 1] = "DONT_KNOW";
    OrgEventStatusResponse[OrgEventStatusResponse["ATTENDING"] = 2] = "ATTENDING";
    OrgEventStatusResponse[OrgEventStatusResponse["NOT_ATTENDING"] = 3] = "NOT_ATTENDING";
    OrgEventStatusResponse[OrgEventStatusResponse["REVOKED"] = 4] = "REVOKED";
})(OrgEventStatusResponse = exports.OrgEventStatusResponse || (exports.OrgEventStatusResponse = {}));
//# sourceMappingURL=status.js.map